import { Box, Stack, styled } from '@mui/material';

export const Container = styled(Box)(({ theme }) => ({
  display: 'grid',
  height: '100%',
  gridTemplate: `'prompt-type-toggle prompt-type-toggle'
                   'fields-switch fields-container'
                   'info-guide sidebar-buttons'`,
  gridTemplateColumns: `${theme.spacing(13.125)} auto`,
  gridTemplateRows: 'auto 1fr auto auto',
}));

export const StyledWrapper = styled(Stack)(({ theme }) => ({
  gridArea: 'prompt-type-toggle',
  alignItems: 'center',
  padding: theme.spacing(2),
  borderBottomWidth: 1,
  borderBottomStyle: 'solid',
  borderBottomColor: theme.palette.grey[700],
}));

export const FormulaFieldsSwitchContainer = styled(Box)(({ theme }) => ({
  gridArea: 'fields-switch',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  alignItems: 'center',
  paddingInline: theme.spacing(1),
  paddingTop: theme.spacing(2),
  overflowY: 'auto',
  borderWidth: 1,
  borderColor: theme.palette.grey[700],
  [theme.breakpoints.up('md')]: {
    borderRightStyle: 'solid',
  },
}));

export const InfoGuideContainer = styled(Box)(({ theme }) => ({
  gridArea: 'info-guide',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  borderWidth: 1,
  borderColor: theme.palette.grey[700],
  [theme.breakpoints.up('md')]: {
    borderRightStyle: 'solid',
  },
  [theme.breakpoints.down('md')]: {
    paddingLeft: theme.spacing(2),
  },
}));

export const FormulaEditorContainer = styled(Box)({
  gridArea: 'fields-container',
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden',
});

export const FormulaEditorWrapper = styled(Box)(({ theme }) => ({
  flexGrowl: 1,
  overflowX: 'hidden',
  overflowY: 'scroll',
  paddingTop: theme.spacing(2),
  paddingLeft: theme.spacing(2),
  paddingRight: theme.spacing(1),
}));

export const ButtonContainer = styled(Box)(({ theme }) => ({
  gridArea: 'sidebar-buttons',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  paddingInline: theme.spacing(2),
  marginBlock: theme.spacing(2),
  height: theme.spacing(5),
}));
